// extracted by mini-css-extract-plugin
export default {"customerTable":"Customers_customerTable__oQzNp","customerContainer":"Customers_customerContainer__JIh7J","inlineLoader":"Customers_inlineLoader__6BNum"};